import { RadioGroup } from "@mui/material";
import { styled } from "@mui/material/styles";
const StyledRadioGroup = styled(RadioGroup)`
  margin-left: 11px;
`;
const FieldWrapper = styled("div")`
  width: 50%;
`;
const FieldsGroup = styled("div")`
  display: flex;
  gap: 8px;
  width: 100%;
  margin-bottom: 8px;
`;
export {
  FieldWrapper,
  FieldsGroup,
  StyledRadioGroup
};
